import { Paragraph } from '@welbe/web-design-system';
import React from 'react';
import { Td, Th } from './TableElements.styles';

type Partials = {
	children: any;
};

type TableHeadProps = {
	id: string;
	width: string;
} & Partials;

type TableRowProps = Partials;

type TableDataProps = Partials;

export const TableHead = ({ children, id, width }: TableHeadProps) => {
	return (
		<Th width={width} id={id}>
			<Paragraph fontSize="12" fontWeight="700">
				{children}
			</Paragraph>
		</Th>
	);
};

export const TableRow = ({ children }: TableRowProps) => {
	return <tr>{children}</tr>;
};

export const TableData = ({ children }: TableDataProps) => {
	return <Td>{children}</Td>;
};
